import { getRowSize } from "./HelperFunctions";

export const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
export const rowSize = getRowSize();
export const numberOfRows = 4;
export const perfEntries = performance.getEntriesByType('navigation');

export const UnitsOfMeasure = {
    bg: "Bag",
    bx: "Box",
    bt: "Bottle",
    cs: "Case",
    c: "Carton",
    dz: "Dozen",
    ea: "Each",
    ft: "Foot",
    gl: "Gallon",
    pk: "Pack",
    pr: "Pair",
    ps: "Pallet",
    rl: "Roll",
    sp: "Spool",
    st: "Set",
    yd: "yard",
}